(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["loomi-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-loomi-featured-carousel]').forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll('[data-loomi-featured-slide]'));
    const previous = carousel.querySelector('[data-loomi-featured-prev]');
    const next = carousel.querySelector('[data-loomi-featured-next]');
    let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));

    if (slides.length < 2 || !previous || !next) return;
    if (activeIndex < 0) activeIndex = 0;

    const showSlide = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === activeIndex);
      });
    };

    previous.addEventListener('click', () => showSlide(activeIndex - 1));
    next.addEventListener('click', () => showSlide(activeIndex + 1));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
